import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Beratung } from "./components/Beratung";
import { Ablauf } from "./components/Ablauf";
import { OnlineBeratung } from "./components/OnlineBeratung";
import { UeberMich } from "./components/UeberMich";
import { Preise } from "./components/Preise";
import { Abgrenzung } from "./components/Abgrenzung";
import { Kontakt } from "./components/Kontakt";
import { Footer } from "./components/Footer";
import { FullBleed } from "./components/FullBleed";
import Admin from "./pages/Admin";

const IMG_FOREST = "https://images.unsplash.com/photo-1527954513726-611b208be16a?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";
const IMG_FIELD = "https://images.unsplash.com/photo-1678028204645-df95d07e2523?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000";

function Landing() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <>
            <Navbar />
            <main>
                <Hero />
                <UeberMich />
                <Beratung />
                <FullBleed
                    testid="divider-forest"
                    src={IMG_FOREST}
                    alt="Ruhiger Wald im Nebel mit sanftem Morgenlicht"
                    quote="Reden hilft. In deinem Tempo, ohne Druck."
                />
                <Ablauf />
                <OnlineBeratung />
                <Preise />
                <Abgrenzung />
                <FullBleed
                    testid="divider-field"
                    src={IMG_FIELD}
                    alt="Goldenes Abendlicht über einem ruhigen Grasfeld"
                    quote="Der erste Schritt darf klein sein."
                />
                <Kontakt />
            </main>
            <Footer />
        </>
    );
}

function App() {
    return (
        <div className="App">
            <Toaster position="top-center" richColors />
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/admin" element={<Admin />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
